import type { LucideIcon } from "lucide-react";
import { Card } from "@/components/ui/card";

interface StaticMetricCardAltProps {
  title: string;
  value: string;
  change: string;
  changeLabel: string;
  icon: LucideIcon;
  variant?: "success" | "warning" | "error" | "info";
}

const variantStyles = {
  success: {
    background: "bg-success-100",
    icon: "text-success-600",
  },
  warning: {
    background: "bg-warning-100",
    icon: "text-warning-600",
  },
  error: {
    background: "bg-error-100",
    icon: "text-error-600",
  },
  info: {
    background: "bg-teal-100",
    icon: "text-teal-600",
  },
};

export function StaticMetricCardAlt({
  title,
  value,
  change,
  changeLabel,
  icon: Icon,
  variant = "success",
}: StaticMetricCardAltProps) {
  const styles = variantStyles[variant];

  return (
    <Card className="overflow-hidden border-0">
      {/* Colored Top Section */}
      <div className={`relative h-24 p-4 ${styles.background}`}>
        <div className="flex items-center justify-between h-full">
          <div className="flex flex-col justify-center">
            <p className="text-neutral-700 text-sm font-medium">{title}</p>
            <p className="text-neutral-900 text-2xl font-bold mt-1">{value}</p>
          </div>
          <div>
            <Icon className={`h-10 w-10 ${styles.icon}`} strokeWidth={1.5} />
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="p-4 bg-card">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-emerald-600">{change}</span>
          <span className="text-sm text-neutral-500">{changeLabel}</span>
        </div>
      </div>
    </Card>
  );
}
